/* The mockup's `.pv-bar`: 44px, one row that scrolls sideways rather than wrapping. */
.toolbar {
  display: flex;
  flex: none;
  align-items: center;
  gap: var(--space-1);
  block-size: 44px;
  padding: 0 var(--space-2);
  overflow-x: auto;
  container-type: inline-size;
  border-bottom: 1px solid var(--border);
  background: var(--surface-raised);
}

/* The content tabs never shrink: the toolbar scrolls sideways instead of cutting a tab off. */
.toolbar > [role="tablist"] {
  flex: none;
}

.separator {
  flex: none;
  inline-size: 1px;
  block-size: 20px;
  margin: 0 var(--space-1);
  background: var(--border);
}

.spacer {
  flex: 1;
}

.srOnly {
  position: absolute;
  inline-size: 1px;
  block-size: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}

.free {
  display: inline-flex;
  flex: none;
}

.number,
.zoom {
  flex: none;
  block-size: var(--control-height);
  padding: 0 var(--space-2);
  border: 1px solid var(--border-control);
  border-radius: var(--radius-control);
  background: var(--surface-raised);
  color: var(--text);
  font: inherit;
  font-size: var(--font-size-13);
}

.number {
  inline-size: 84px;
}

.number:focus-visible,
.zoom:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: -1px;
}

/* An icon link that looks like the ghost icon buttons around it. */
.iconLink {
  display: inline-grid;
  flex: none;
  place-items: center;
  inline-size: var(--control-height);
  block-size: var(--control-height);
  border-radius: var(--radius-control);
  color: var(--text-muted);
}

.iconLink:hover {
  background: var(--state-hover);
  color: var(--text);
}

.iconLink:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 2px;
}

/*
 * Below 1024px the zoom is left out and the content tabs keep only their glyphs, as in the mockup
 * (`.hide-sm`); the names stay for assistive tools.
 */
@media (max-width: 1023.98px) {
  .zoom {
    display: none;
  }

  .toolbar [role="tab"] [data-tab-label] {
    position: absolute;
    inline-size: 1px;
    block-size: 1px;
    overflow: hidden;
    clip-path: inset(50%);
    white-space: nowrap;
  }
}

/*
 * The preview pane is a share of the window, so the bar answers to its own width, not the viewport's:
 * under 752px (content box) the content tabs keep only their glyphs (the names stay for assistive
 * tools) and under 640px the zoom goes too, so the bar never scrolls sideways at the widths the
 * editor is split. The whole bar with the names needs 749px inside its padding, so the 780px pane of
 * a 1440px window (763px inside) shows them, as the mockup does.
 */
@container (max-width: 751.98px) {
  .toolbar [role="tab"] [data-tab-label] {
    position: absolute;
    inline-size: 1px;
    block-size: 1px;
    overflow: hidden;
    clip-path: inset(50%);
    white-space: nowrap;
  }
}

@container (max-width: 639.98px) {
  .zoom {
    display: none;
  }
}
